// src/features/settings/useGeneralSettings.ts
// Read side comes directly from useGuild()'s already-fetched guilds
// array, same as ChannelsPage — only the PATCH (write) side needs its
// own hook here.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../../lib/api';

export interface GeneralSettings {
  modRoleId?: string | null;
  vipRoleId?: string | null;
}

export function useUpdateGeneralSettings(guildId: string | null) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (settings: GeneralSettings) =>
      apiFetch(`/api/guilds/${guildId}`, { method: 'PATCH', body: JSON.stringify({ settings }) }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['guilds'] }),
  });
}
